/** Ready feed2 rows for the All tab. This subscribes to the existing service;
 * it does not start a provider poller or combine odds across sources. */
import { alignFork } from '../lib/align';
import type { Fork } from '../lib/protocol';
import { FeedClient } from '../ws/client';

let client: FeedClient | null = null;
let forks = new Map<string, Fork>();
let generation = 0;

export const allFeed2Snapshot = (): Map<string, Fork> => forks;

export function startAllFeed2(publish: () => void): void {
  if (client !== null) return;
  const gen = ++generation;
  let received = false;
  const current = (): boolean => gen === generation;
  const clear = (): void => {
    if (!current()) return;
    forks = new Map();
    publish();
  };
  const scheme = location.protocol === 'https:' ? 'wss' : 'ws';
  client = new FeedClient(`${scheme}://${location.host}/tests-api/ws`, 3, {
    onState: (incoming) => {
      if (!current()) return;
      received = true;
      forks = incoming;
      publish();
    },
    onStatus: (status) => {
      if (status !== 'live') {
        if (status !== 'connecting') received = true;
        clear();
      }
    },
    onProtocolMismatch: () => { received = true; clear(); },
    onSeatRevoked: () => { received = true; clear(); },
  });
  client.connect();
  // Bootstrap once. A late REST response must never resurrect a deleted row,
  // overwrite an empty socket frame, or cross a tab switch.
  void (async () => {
    try {
      const response = await fetch('/tests-api/v1/signals', {
        credentials: 'same-origin', signal: AbortSignal.timeout(4000),
      });
      if (!response.ok) return;
      const body = await response.json() as { forks?: Fork[]; proto?: number };
      if (!current() || received || body.proto !== 3 || !Array.isArray(body.forks)) return;
      const now = Date.now();
      forks = new Map(body.forks.map(f => [f.id, { ...alignFork(f), at: now }]));
      publish();
    } catch { /* Other sources continue to display. */ }
  })();
}

export function stopAllFeed2(): void {
  generation += 1;
  client?.close();
  client = null;
  forks = new Map();
}
